var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivePositionsIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5296_14900)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.145508,
    width: 52,
    height: 52,
    rx: 12,
    fill: "#F3FDF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9021 17.6504C26.4544 17.6504 26.9021 17.2027 26.9021 16.6504C26.9021 16.0981 26.4544 15.6504 25.9021 15.6504C25.3498 15.6504 24.9021 16.0981 24.9021 16.6504C24.9021 17.2027 25.3498 17.6504 25.9021 17.6504ZM30.8026 24.7402L35.7436 21.6959C35.8909 21.607 36.0762 21.7263 36.0559 21.8965L34.1161 36.6383C34.0907 36.8414 33.9155 36.9937 33.7123 36.9937H18.0946C17.8889 36.9937 17.7163 36.8388 17.6883 36.6383L15.7485 21.8965C15.7256 21.7263 15.9135 21.607 16.0582 21.6959L21.0018 24.7402L25.7372 18.4205C25.7562 18.3951 25.7809 18.3744 25.8094 18.3602C25.8378 18.346 25.8691 18.3386 25.9009 18.3386C25.9327 18.3386 25.9641 18.346 25.9925 18.3602C26.0209 18.3744 26.0456 18.3951 26.0647 18.4205L30.8026 24.7402ZM23.0432 30.4582C23.0432 32.0349 24.3254 33.3172 25.9022 33.3172C27.479 33.3172 28.7612 32.0349 28.7612 30.4582C28.7612 28.8814 27.479 27.5992 25.9022 27.5992C24.3254 27.5992 23.0432 28.8814 23.0432 30.4582ZM24.6784 30.4582C24.6784 29.7803 25.2268 29.2318 25.9022 29.2318C26.5776 29.2318 27.126 29.7828 27.126 30.4582C27.126 31.1361 26.5776 31.6846 25.9022 31.6846C25.2268 31.6846 24.6784 31.1336 24.6784 30.4582ZM14.9966 21.2129C15.5489 21.2129 15.9966 20.7652 15.9966 20.2129C15.9966 19.6606 15.5489 19.2129 14.9966 19.2129C14.4443 19.2129 13.9966 19.6606 13.9966 20.2129C13.9966 20.7652 14.4443 21.2129 14.9966 21.2129ZM37.9585 20.2129C37.9585 20.7652 37.5108 21.2129 36.9585 21.2129C36.4062 21.2129 35.9585 20.7652 35.9585 20.2129C35.9585 19.6606 36.4062 19.2129 36.9585 19.2129C37.5108 19.2129 37.9585 19.6606 37.9585 20.2129Z",
    fill: "#14A800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5296_14900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(0.145508)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePositionsIcons);
export default __webpack_public_path__ + "static/media/active-positions-icons.f0aa1bae906d6c29488a69b6b10e5cba.svg";
export { ForwardRef as ReactComponent };